<template>
	<Icon v-bind="$props">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 388 512"
			class="icon-file-powerpoint"
		>
			<path
				opacity=".4"
				class="duotone"
				d="M249.4 0l69.2 69.2 69.2 69.2-110.7 0c-15.3 0-27.7-12.4-27.7-27.7L249.4 0z"
			/>
			<path
				class="duotone"
				d="M101.4 373.7h17.3c2.3 0 4.5-.2 6.6-.7c1.3-.3 2.6-.6 3.7-1.1c.8-.3 1.5-.7 2.1-1.1c1.8-1.1 3.2-2.5 4.2-4.3c1.1-1.9 1.6-4.2 1.6-7c0-3-.7-5.4-2.2-7.1c-1.3-1.9-3.1-3.3-5.3-4.3c-2.1-1-4.5-1.6-7.1-1.8c-2.7-.3-5.2-.5-7.6-.5H101.4v27.9zM249.4 0l0 110.7c0 15.3 12.4 27.7 27.7 27.7l110.7 0 0 345.9c0 15.3-12.4 27.7-27.7 27.7L27.9 512C12.6 512 .3 499.6 .3 484.3L.3 27.7C.3 12.4 12.6 0 27.9 0L249.4 0zM233.2 166c0-4.2-1.9-8.4-5.6-11c-6.1-4.6-14.8-3.3-19.4 2.9l-49.7 67L134.9 193c-2.5-3.4-6.4-5.4-10.6-5.6c-4.2-.2-8.2 1.6-11 4.8L72.8 239c-2.1 2.4-3.2 5.4-3.4 8.4c-.2 4.1 1.4 8.3 4.8 11.2c5.8 5 14.5 4.4 19.5-1.4L123 223.3l24.4 33c2.6 3.5 6.7 5.6 11.1 5.6c4.4 0 8.5-2.1 11.1-5.6l60.8-82c1.8-2.5 2.7-5.4 2.7-8.3zM75.5 323.9l0 117.6 25.9 0 0-45.8 18.9 0c6.2 0 11.9-.6 17.3-1.7c5.3-1.2 9.9-3.2 13.8-6c3.9-2.8 6.9-6.5 9.1-11.1s3.3-10.4 3.3-17.3c0-7-1.2-12.7-3.7-17.3c-2.3-4.6-5.5-8.3-9.6-11c-1.6-1.1-3.4-2.1-5.2-3c-2.7-1.2-5.7-2.2-8.9-2.9c-5.4-1.1-11.2-1.7-17.3-1.7l-43.7 0z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from '../Icon'
export default {
	name: 'PowerpointIcon',
	components: { Icon },
	props,
}
</script>
<style scoped>
svg path {
	fill: #e64c1d !important;
}
</style>
